module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/photographer_sns_06-07e2793da6f477ac1d44eb5261567e07.jpg";